__turbopack_context__.v({
  "previewOuter": "styles-module__9pLnma__previewOuter",
  "previewRoundedClip": "styles-module__9pLnma__previewRoundedClip",
  "previewSurface": "styles-module__9pLnma__previewSurface",
  "previewToneScope": "styles-module__9pLnma__previewToneScope",
  "root": "styles-module__9pLnma__root",
});
